import { httpDelete, httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  CreateWebhookFn,
  GetWebhooksFn,
  UpdateWebhookFn,
} from "./webhooks.types";

const getWebhooks: GetWebhooksFn = async (query) => {
  const { uuid, ...rest } = query ?? {};

  if (uuid) {
    return httpGet(`/webhooks/${uuid}`, rest);
  }

  return httpGet("/webhooks", rest);
};

const createWebhook: CreateWebhookFn = async (data) => {
  return await httpPost(`/webhooks`, data);
};

const updateWebhook: UpdateWebhookFn = async (data) => {
  const { uuid, ...rest } = data;
  return await httpPatch(`/webhooks/${uuid}`, rest);
};

const deleteWebhook = async (uuid: string) => {
  return await httpDelete(`/webhooks/${uuid}`);
};

export const WebhooksAPI = {
  get: getWebhooks,
  create: createWebhook,
  update: updateWebhook,
  delete: deleteWebhook,
};
